import React from 'react';
import './DynamicGrid.css'; // Import your CSS file for styling
import { FaHeartbeat, FaDna, FaCircleNotch, FaEllipsisH } from 'react-icons/fa';

// Icon mapping
const iconMap = {
    FaHeartbeat: FaHeartbeat,
    FaDna: FaDna,
    FaCircleNotch: FaCircleNotch,
    FaEllipsisH: FaEllipsisH
};

const DynamicGrid = ({ items }) => {
    const { sign_and_symptoms, inheritance, age_of_onset, prevelance } = items || {};
    const extractedItems = [
        // { id: 5, name: 'Sign and Symptoms', detail: sign_and_symptoms, icon: 'FaHeartbeat' },
        { id: 6, name: 'Age of Onset', detail: age_of_onset, icon: 'FaCircleNotch' },
        { id: 7, name: 'Prevalence', detail: prevelance, icon: 'FaEllipsisH' },
        // { id: 8, name: 'Inheritance', detail: inheritance, icon: 'FaDna' }
    ];

    return (
        <div className="grid-container">
            {extractedItems.map(item => {
                const IconComponent = iconMap[item.icon]; // Get the correct icon component

                return (
                    <div key={item.id} className="grid-item">
                        <div className='icon-container'>
                            {IconComponent && <IconComponent className='icon' size={35} />}
                        </div>

                        <h3 className='gridHeader'>
                            {item.name}
                        </h3>
                        <div
                            className='condition-detail'
                            // style={{ fontSize: 18, }}
                            dangerouslySetInnerHTML={{
                                __html: item?.detail?.replace(/\${CHAR\(10\)}/g,'')
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default DynamicGrid;
